import React from 'react';

// Matches http(s) URLs and bare www. links.
const URL_SPLIT_REGEX = /((?:https?:\/\/|www\.)[^\s<]+[^\s<.,:;"')\]}])/gi;
const URL_TEST_REGEX = /^(?:https?:\/\/|www\.)/i;

/**
 * Convert a plain string into an array of React nodes where URLs become
 * clickable anchor tags.
 */
export function renderTextWithLinks(text, linkStyle = {}) {
  if (!text) return null;
  const parts = String(text).split(URL_SPLIT_REGEX);

  return parts.map((part, idx) => {
    if (!part) return null;
    if (URL_TEST_REGEX.test(part)) {
      const href = part.startsWith('http') ? part : `https://${part}`;
      return (
        <a
          key={idx}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
          style={{ color: '#0a66c2', textDecoration: 'underline', wordBreak: 'break-word', ...linkStyle }}
        >
          {part}
        </a>
      );
    }
    return <React.Fragment key={idx}>{part}</React.Fragment>;
  });
}

/**
 * Render multi-paragraph text with clickable links.
 * Splits on blank lines into <p> blocks and linkifies each.
 */
export function RichText({ text, className, style, linkStyle }) {
  if (!text) return null;
  const paragraphs = String(text)
    .split(/\n{2,}/)
    .map((segment) => segment.trim())
    .filter(Boolean);

  if (paragraphs.length === 0) return null;

  return paragraphs.map((para, idx) => (
    <p
      key={idx}
      className={className}
      style={{ marginBottom: '0.75rem', whiteSpace: 'pre-wrap', wordBreak: 'break-word', ...style }}
    >
      {renderTextWithLinks(para, linkStyle)}
    </p>
  ));
}

export default RichText;
